﻿import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./Themes/cookieconsent.theme.css";
document.documentElement.classList.add('cc--darkmode');

window.CookieConsent = CookieConsent;

CookieConsent.run({
    // TODO: Hide from bots should be true in production
    hideFromBots: true,
    guiOptions: {
        consentModal: {
            layout: "cloud inline",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: true
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            enabled: true,
            readOnly: true
        },
        functionality: {
        },
        analytics: {
            readOnly: false,
            services: {
                ga: {
                    label: 'Google Analytics',
                    onAccept: () => {
                    },
                    onReject: () => {
                    },
                    cookies: [
                        {
                            name: /^(_ga|_gid)/
                        }
                    ]
                },

            },
            autoClear: {
                reloadPage: true,
            }
        }
    },
    // TODO: Links überprüfen 
    language: {
        default: "de",
        translations: {
            de: {
                consentModal: {
                    title: "Hallo Reisende, es ist Kekszeit!",
                    description: "Unsere Website verwendet Cookies, um die Funktionalität zu verbessern, Inhalte zu personalisieren und Ihre allgemeine Erfahrung zu optimieren.",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Alle ablehnen",
                    showPreferencesBtn: "Präferenzen verwalten",
                    footer: '<a class="zis-link" href=\"/rechtliches/datenschutzerklaerung\" hx-target="#zis-swapper">Datenschutzerklärung</a>\n<a class="zis-link" href=\"/rechtliches/impressum\"  hx-target="#zis-swapper">Impressum</a>'
                },
                preferencesModal: {
                    title: "Cookie Präferenzen",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Alle ablehnen",
                    savePreferencesBtn: "Präferenzen speichern",
                    closeIconLabel: "Modal schließen",
                    serviceCounterLabel: "Dienst|Dienste",
                    sections: [
                        {
                            title: "Cookie-Nutzung",
                            description: 'Cookies sind sehr kleine Textdateien, die auf Ihrem Rechner gespeichert werden, wenn Sie eine Website besuchen. Wir verwenden Cookies für eine Reihe von Auswertungen, um damit Ihren Besuch auf unserer Website kontinuierlich verbessern zu können (z. B. damit Ihnen Ihre Login-Daten erhalten bleiben).<br/><br/>Sie können Ihre Einstellungen ändern und verschiedenen Arten von Cookies erlauben, auf Ihrem Rechner gespeichert zu werden, während Sie unsere Webseite besuchen.Sie können auf Ihrem Rechner gespeicherte Cookies ebenso weitgehend wieder entfernen.Bitte bedenken Sie aber, dass dadurch Teile unserer Website möglicherweise nicht mehr in der gedachten Art und Weise nutzbar sind.<br/><br/><a href="/rechtliches/datenschutzerklaerung" hx-target="#zis-swapper">Datenschutzerklärung</a>&nbsp;&nbsp;&nbsp;<a class="pl-4" href="/rechtliches/impressum" hx-target="#zis-swapper">Impressum</a>'
                        },
                        {
                            title: "Technisch notwendige Cookies <span class=\"pm__badge\">Immer aktiviert</span>",
                            description: "Diese Cookies sind für die Bereitstellung von Diensten, die über unsere Website verfügbar sind, und für die Verwendung bestimmter Funktionen unserer Website von wesentlicher Bedeutung.<br/><br/>Ohne diese Cookies können wir Ihnen bestimmte Dienste auf unserer Website nicht zur Verfügung stellen.",
                            linkedCategory: "necessary"
                        },
                        //{
                        //    title: "Funktionalitäts-Cookies",
                        //    description: "Diese Cookies ermöglichen es unserer Website, sich an die von Ihnen getroffenen Entscheidungen zu erinnern, wie z.B. Ihre Spracheinstellungen, und bieten erweiterte, personalisierte Funktionen. Sie ermöglichen ein maßgeschneidertes Erlebnis und sorgen dafür, dass die Website wie erwartet funktioniert. Diese Cookies können Ihre Surf-Aktivitäten auf anderen Websites nicht verfolgen.",
                        //    linkedCategory: "functionality"
                        //},
                        {
                            title: "Tracking und Performance Cookies",
                            description: "Diese Cookies werden zum Sammeln von Informationen verwendet, um den Verkehr auf unserer Website und die Nutzung unserer Website durch Besucher zu analysieren.<br/><br/>Diese Cookies können beispielsweise nachverfolgen, wie lange Sie auf der Website verweilen oder welche Seiten Sie besuchen. So können wir verstehen, wie wir unsere Website für Sie verbessern können.<br/><br/>Die durch diese Tracking- und Performance-Cookies gesammelten Informationen identifizieren keinen einzelnen Besucher.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Weitere Informationen",
                            description: "Bei Fragen in Bezug auf unseren Umgang mit Cookies und Ihrer Privatsphäre kontaktieren Sie uns bitte. Details finden Sie in unserer <a class=\"cc__link\" href=\"/rechtliches/datenschutzerklaerung\">Datenschutzrichtlinie</a>."
                        }
                    ]
                }
            }
        }
    }
 
});